import { SvgIcon } from "@mui/material";

interface ILinkedinProps {
  color?: string;
  className?: string;
}

const Linkedin: React.FC<ILinkedinProps> = (props) => {
  return (
    <SvgIcon
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.4583 0C22.1656 0 22.8439 0.280951 23.344 0.781048C23.844 1.28115 24.125 1.95942 24.125 2.66667V21.3333C24.125 22.0406 23.844 22.7189 23.344 23.219C22.8439 23.719 22.1656 24 21.4583 24H2.79167C2.08442 24 1.40615 23.719 0.906048 23.219C0.405951 22.7189 0.125 22.0406 0.125 21.3333V2.66667C0.125 1.95942 0.405951 1.28115 0.906048 0.781048C1.40615 0.280951 2.08442 0 2.79167 0H21.4583ZM20.7917 20.6667V13.6C20.7917 12.4472 20.3337 11.3416 19.5186 10.5264C18.7034 9.71128 17.5978 9.25333 16.445 9.25333C15.3117 9.25333 13.9917 9.94667 13.3517 10.9867V9.50667H9.63167V20.6667H13.3517V14.0933C13.3517 13.0667 14.1783 12.2267 15.205 12.2267C15.7001 12.2267 16.1749 12.4233 16.5249 12.7734C16.875 13.1235 17.0717 13.5983 17.0717 14.0933V20.6667H20.7917ZM5.29833 7.41333C5.89242 7.41333 6.46217 7.17733 6.88225 6.75725C7.30233 6.33717 7.53833 5.76742 7.53833 5.17333C7.53833 3.93333 6.53833 2.92 5.29833 2.92C4.70071 2.92 4.12757 3.1574 3.70499 3.57999C3.2824 4.00257 3.045 4.57571 3.045 5.17333C3.045 6.41333 4.05833 7.41333 5.29833 7.41333ZM7.15167 20.6667V9.50667H3.45833V20.6667H7.15167Z"
        fill={props.color || "black"}
      />
    </SvgIcon>
  );
};

export default Linkedin;
